import React from "react";
import { TogalProvider } from "../togal/TogalContext";
import { AtoProvider } from "../ato/AtoContext";
import { OstProvider } from "../ost/OstContext";

const QtoIntegrationProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <TogalProvider>
    <AtoProvider>
      <OstProvider>{children}</OstProvider>
    </AtoProvider>
  </TogalProvider>
);

export default QtoIntegrationProviders;
